<template>
    <ValidationProvider
        :name="validationName"
        :rules="validationRules"
        v-slot="{ errors }"
    >
        <v-text-field
            autocomplete="off"
            :clearable="inputIsClearable"
            dense
            :disabled="inputDisabled"
            :error-messages="errors"
            filled
            hide-details="auto"
            :hint="inputHint"
            :id="id"
            outlined
            :placeholder="inputPlaceholder"
            :prepend-inner-icon="inputIcon"
            :readonly="inputReadOnly"
            :type="inputType"
            :value="inputValue"
            v-bind="$attrs"
            @blur="$emit('blur', $event)"
            @click:clear="$emit('click:clear', $event)"
            @click:prepend-inner="$emit('click:prepend-inner', $event)"
            @input.native="$emit('input', $event)"
        />
    </ValidationProvider>
</template>

<script>
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
    ...required,
    message: "Field cannot be empty.",
});

extend("password", {
    params: ["target"],
    validate(value, { target }) {
        return value === target;
    },
    message: "Password doesn't match.",
});

export default {
    name: "customTextField",
    props: {
        errors: { default: null },
        id: { default: null, type: String },
        inputDisabled: { default: false, type: Boolean },
        inputHint: { default: null, type: String },
        inputIcon: { default: null, type: String },
        inputIsClearable: { default: false, type: Boolean },
        inputPlaceholder: { default: "Placeholder", type: String },
        inputReadOnly: { default: false, type: Boolean },
        inputType: { default: "text", type: String },
        inputValue: { default: "", type: String },
        validationName: { default: "ValidationProviderName", type: String },
        validationRules: { default: null, type: String },
    },
    // Lifecycle hooks.
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
};
</script>

